module.exports = __webpack_public_path__ + "src/app/_content/imgs/bmw/icons/social/twitter-default@2x.png?4aca5632a57f8d34fdce76b47b95aab2";